<template>
    <div id="cookie-declaration-container"></div>
</template>

<script>
// We do this here because Vue is wrapped around the entire page and causes hell.
export default {
    name: "CookiebotCookiePolicyComponent",
    mounted() {
        this.loadCookiebotScript();
    },
    beforeUnmount() {
        this.removeCookiebotScript();
    },
    methods: {
        loadCookiebotScript() {
            const script = document.createElement("script");
            script.id = "CookieDeclaration";
            script.src =
                "https://consent.cookiebot.com/755123fc-6052-4e6a-b20b-e3fa5a28bae1/cd.js";
            script.async = true;
            script.setAttribute("data-cookiebot", "true");
            document
                .getElementById("cookie-declaration-container")
                ?.appendChild(script);
        },
        removeCookiebotScript() {
            const script = document.getElementById("CookieDeclaration");
            if (script) {
                script.remove();
            }
        },
    },
};
</script>
